"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRedux = require("react-redux");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _VersionsTableModal = _interopRequireDefault(require("../VersionsTableModal"));
var styles = {
  "button": "VersionsTableButton__button__2Iv71"
}; 
require('./VersionsTableButton.css');
var VersionsTableButton = function VersionsTableButton(_ref) {
  var asset = _ref.asset;
  var canEdit = (0, _reactRedux.useSelector)(function (state) {
    return _assets.selectors.canShowEdition(state, asset);
  });
  var _useModals = (0, _exchangeReactHooks.useModals)(),
    openModal = _useModals.openModal;
  var isVersionsTableDisabled = (0, _exchangeReactHooks.useVersionsTableDisabled)();
  var label = canEdit ? 'Manage versions' : 'View versions';
  return !isVersionsTableDisabled ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    testId: "asset-versions-button",
    onClick: function onClick() {
      return openModal(_VersionsTableModal.default, {
        asset: asset
      });
    },
    "aria-describedby": "asset-versions-description",
    "aria-label": label,
    className: styles.button,
    size: "sm",
    kind: "secondary"
  }, label, /*#__PURE__*/_react.default.createElement("span", {
    id: "asset-versions-description",
    className: "visually-hidden"
  }, "Opens versions modal for ", asset.minorVersion, " minor version")) : null;
};
var _default = exports.default = VersionsTableButton;
//# sourceMappingURL=VersionsTableButton.js.map